import React from 'react';

import { Element } from '../Element/element';

export const Form = props => <Element flex TagName="form" {...props} />;
